"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonAptosUtils = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var config_1 = require("./config");
var dataTypes = __importStar(require("./dataTypes"));
var CommonAptosUtils = /** @class */ (function (_super) {
    __extends(CommonAptosUtils, _super);
    function CommonAptosUtils(core) {
        return _super.call(this, CommonAptosUtils.moduleName, core) || this;
    }
    CommonAptosUtils.create = function (core) {
        return new CommonAptosUtils(core !== null && core !== void 0 ? core : common_core_1.CoreProvider.getDefault());
    };
    CommonAptosUtils.prototype.setup = function () {
        config_1.CommonAptosUtilsConfigSetup.register(this.core.config);
    };
    CommonAptosUtils.prototype.start = function () {
        // Nothing
    };
    Object.defineProperty(CommonAptosUtils.prototype, "AptosAddress", {
        get: function () {
            return dataTypes.AptosAddress;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonAptosUtils.prototype, "AptosNative", {
        get: function () {
            return dataTypes.AptosNative;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommonAptosUtils.prototype, "AptosNetwork", {
        get: function () {
            return dataTypes.AptosNetwork;
        },
        enumerable: false,
        configurable: true
    });
    CommonAptosUtils.moduleName = 'aptosUtils';
    return CommonAptosUtils;
}(common_core_1.Module));
exports.CommonAptosUtils = CommonAptosUtils;
//# sourceMappingURL=CommonAptosUtils.js.map